@if (isLoading) {
  <app-chart-loading></app-chart-loading>
} @else {
  <div [id]="config.chartId" class="radial-gauge-canvas" [style.height.px]="config.height ?? 220"></div>
}
